<template>
  <div class="container">
    <el-row style="margin-bottom:20px">
        <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
        <el-breadcrumb-item :to="{ path: '/director-workmaster' }">工作通</el-breadcrumb-item>
        <el-breadcrumb-item>通讯录</el-breadcrumb-item>
      </el-breadcrumb>
    </el-row>
    

    <el-row :gutter="20">

      <el-col :span="4" :xs="24">
        <div class="head-container" style="margin-bottom:20px">
          <el-select
                v-model="searchWorkFormData.company_app_id" 
                placeholder="请选择公司"
                clearable
                filterable
                style="width:100%"
                @change="selectCompany"
              >
              <el-option
                v-for="item in companys"
                :key="item.company_app_id"
                :label="item.company_name"
                :value="item.company_app_id"
              />
          </el-select>
        </div>
        <div class="head-container">
          <el-tree

            :data="workList"
            :props="defaultProps"
            :expand-on-click-node="false"
            :filter-node-method="filterNode"
            ref="tree"
            @node-click="handleNodeClick"
          />
        </div>
      </el-col>
      <!--用户数据-->
      <el-col :span="20" :xs="24">
        <el-form :model="enrollSearchFormData" ref="queryForm" :inline="true"  label-width="68px">
          <el-form-item label="用户名称" prop="name">
            <el-input
              v-model="enrollSearchFormData.name"
              placeholder="请输入用户名称"
              clearable
              size="small"
              style="width: 240px"
            />
          </el-form-item>

          <el-form-item label="状态" prop="type">
            <el-select
              v-model="enrollSearchFormData.type" placeholder="全部"
                clearable
                filterable
              >
              <el-option label="在职" value="1"></el-option>
              <el-option label="淘汰" value="2"></el-option>
              <el-option label="备选" value="3"></el-option>
          </el-select>
          </el-form-item>
         
          <el-form-item>
            <el-button type="primary" icon="el-icon-search" size="mini" @click="handleQuery">搜索</el-button>
            <el-button icon="el-icon-refresh" size="mini" @click="resetQuery">重置</el-button>
          </el-form-item>
         
        </el-form>

        <!--
        <el-row  class="mb8" style="text-align:right">
          <el-col :span="6" :offset="18">
            <el-button
              plain
              icon="el-icon-upload2"
              size="mini"
            >导入</el-button>
          </el-col>
         
        </el-row>
-->
        <el-table 
          @selection-change="handleSelectionChange"
          ref="table"
          :data="enrollPageProps.records"
          element-loading-text="正在查询"
          fit
          stripe
          highlight-current-row>

          <el-table-column type="selection" width="50" align="center" />
          <el-table-column align="center" label="职位" prop="title"> </el-table-column>
          <el-table-column align="center" label="昵称" prop="nickname"> </el-table-column>
          <el-table-column align="center" label="电话" prop="mobile"> </el-table-column>

         
          <el-table-column
            label="操作"
            align="center"
            width="160"
            class-name="small-padding fixed-width"
          >
            <template slot-scope="scope">
              <el-button
                size="mini"
                type="text"
                icon="el-icon-edit"
                @click="detailInfo(scope.row.enroll_id)"
              >详情</el-button>
              
            </template>
          </el-table-column>
        </el-table>
        <div style="text-align:center;padding:20px">
          <!--分页-->
          <el-pagination
            background
            layout="total, sizes, prev, pager, next, jumper"
            :total="enrollPageProps.total"
            :page-size="enrollPageProps.pageSize"
            :page-sizes="[5, 10, 50, 100]"
            :current-page="enrollPageProps.pageNum"
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
          />
      </div>
      
      </el-col>
    </el-row>

    <contacts-info-dialog ref="contactsInfoDialog" ></contacts-info-dialog>

  </div>
</template>

<script>
import { workList,companyList,enrollList,enrollInfo} from "@/api/director/workmaster/index";
import contactsInfoDialog from "@/views/director/workmaster/contacts/contacts-info-dialog.vue";

export default {
  name: "User",
  components: { contactsInfoDialog},
  data() {
    return {
      // 遮罩层
      loading: false,
      // 选中数组
      ids: [],
      // 非单个禁用
      single: true,
      // 非多个禁用
      multiple: true,
    
    
      defaultProps: {
        children: "children",
        label: "label"
      },
      // 查询参数
      queryParams: {
        pageNum: 1,
        pageSize: 10,
      },
      // 表单校验
      rules: {
        email: [
          {
            type: "email",
            message: "'请输入正确的邮箱地址",
            trigger: ["blur", "change"]
          }
        ],
        phonenumber: [
          {
            pattern: /^1[3|4|5|6|7|8|9][0-9]\d{8}$/,
            message: "请输入正确的手机号码",
            trigger: "blur"
          }
        ]
      },
      searchWorkFormData:{
        company_app_id:"",
        page:1,
        limit:10,
      },

      workList:[],
      companys:[],

      enrollSearchFormData:{
        project_id:"",
        job_id:"",
        type:"",//
        name:"",
        page:"",
        limit:"",
      },
      enrollPageProps: {
          records:[],
          total: 0,
          pageSize: 10,
          pageNum: 1
        },
    };
  },
  watch: {
    // 根据名称筛选部门树
    deptName(val) {
      this.$refs.tree.filter(val);
    }
  },
  created() {
    this.getWorkList();
    this.getCompanyList();
    this.getEnrollList();
  },
  methods: {

     //职位列表
   getWorkList(){
      var that = this;
      workList(this.searchWorkFormData).then((response) => {
        console.log('workList',response);
        var workList=response.data.data;
        /*
        
          children: 'children',
          label: 'label'
          */ 
         var list=[];
        for (let item of workList) {
          var obj={
            level:1,
            id:item.project_id,
            label:item.name,
            children:[],
          }
          var jobs=[];
          if(item.job&&item.job.length>0){
            for (let item2 of item.job) {
              var job={
                level:2,
                id:item2.job_id,
                label:item2.title,
              }
              jobs.push(job);
            }
          }

          obj.children=jobs;

          list.push(obj);
          
        }
        console.log("list",list);
        this.workList=list;

      });
    },

  // 节点单击事件
   handleNodeClick(data) {
      var that=this;
      console.log(data);
      if(data.level==1){
        that.enrollSearchFormData.project_id=data.id
        that.enrollSearchFormData.job_id=""
      }

      if(data.level==2){
        that.enrollSearchFormData.project_id=""
        that.enrollSearchFormData.job_id=data.id
      }
      that.getEnrollList();
      
     
    },


    getCompanyList(){
      var that = this;
      companyList({}).then((response) => {
        that.companys=response.data;
      });
    },

    selectCompany(e){
      console.log("e",e);
      var that=this;
      that.searchWorkFormData.company_app_id=e;
      that.getWorkList();

    },


    getEnrollList(){
      var that = this;
      that.enrollSearchFormData.page=that.enrollPageProps.pageNum;
      that.enrollSearchFormData.limit=that.enrollPageProps.pageSize;

      enrollList(that.enrollSearchFormData).then((response) => {
        that.enrollPageProps.records=response.data.data;
        that.enrollPageProps.total=response.data.total;
      });
    },

    // 当前页变更
    handleCurrentChange(num) {
      this.enrollPageProps.pageNum = num
      this.getEnrollList()
    },

    // 每页显示页面数变更
    handleSizeChange(size) {
      this.enrollPageProps.pageSize = size
      this.getEnrollList()
    },

  

    // 筛选节点
    filterNode(value, data) {
      if (!value) return true;
      return data.label.indexOf(value) !== -1;
    },
  

    /** 搜索按钮操作 */
    handleQuery() {
      this.getEnrollList();
    },
    /** 重置按钮操作 */
    resetQuery() {
      this.resetForm("queryForm");
      this.handleQuery();
    },


    // 多选框选中数据
    handleSelectionChange(selection) {
      this.ids = selection.map(item => item.userId);
      this.single = selection.length != 1;
      this.multiple = !selection.length;
    },

    detailInfo(enroll_id){
      this.$refs.contactsInfoDialog.init(enroll_id);
    }
    
  }
};
</script>